const formatDoctorName = (name, type = "doctor") => {
    if (!name) return '';
    let formattedName = name.replace(/^dr[_\-\.\s]*/i, ''); // Remove dr_ or dr- or dr. or dr (case-insensitive)
    formattedName = formattedName
        .split(/[\s_]+/) // Split by space or underscore
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    // Remove any remaining "Dr." prefixes (not just at the beginning)
    formattedName = formattedName.replace(/(^|\s)(Dr\.?\s*)+/gi, '$1');
    
    // Only add "Dr." prefix if type is "doctor"
    return type === "doctor" ? `Dr. ${formattedName}` : formattedName;
};

export default formatDoctorName;


// Dr. Dr Raghuveer Raju Boosa this showing this case this should be Dr. Raghuveer Raju Boosa
 
